// extracted by mini-css-extract-plugin
module.exports = {"arrow":"component-link_arrow__3ulHp","externalLink":"component-link_externalLink__hzTci","blackLink":"component-link_blackLink__AD09S"};